<section class="block-em" *ngIf="item">
    <header class="block-header">
        <div>
            <h2>{{item.index}}. {{translate(item.title, 'lv')}}</h2>
            <div class="text-sub">{{translate(item.title, 'en')}}</div>
        </div>
    </header>

    <div>
        <ng-content></ng-content>
    </div>
</section>
